<template>
  <b-modal
    v-model:active="isModalActiveComputed"
    has-modal-card
    trap-focus
    :can-cancel="false"
    class="fileUploadModal"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p
          class="modal-card-title"
          :aria-label="modalMessageComputed"
        >
          {{ modalMessageComputed }}
        </p>
      </header>
      <section class="modal-card-body">
        <b-notification
          v-if="uploadProgressComputed > 0"
          type="is-light"
          size="is-small"
          has-icon
          aria-close-label="Close notification"
          class="border-notif-info-light"
        >
          <b-progress
            v-if="uploadProgressComputed < 101"
            :value="uploadProgressComputed"
            :max="100"
            type="is-dark"
            show-value
            size="is-medium"
          >
            <span> {{ uploadProgressComputed }}% </span>
          </b-progress>
          {{ $t("dataTypesManagement.info_upload") }}
        </b-notification>
      </section>
      <footer class="modal-card-foot">
        <b-button
          v-if="uploadProgressComputed > 0 && uploadProgressComputed < 100"
          type="is-danger"
          :aria-label="$t('referencesManagement.cancel-upload')"
          @click="cancelUpload"
        >
          {{ $t("referencesManagement.cancel-upload") }}
        </b-button>
        <b-button
          v-if="uploadProgressComputed === 100"
          type="is-primary"
          :aria-label="$t('referencesManagement.continue-browsing')"
          @click="continueNavigation"
        >
          {{ $t("referencesManagement.continue-browsing") }}
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script lang="ts">
import { computed } from "vue";
import { BButton, BModal, BNotification, BProgress } from "buefy";
import "@/style/components/FileUploadModal.scss";

export default {
  name: "FileUploadModal",
  components: { BButton, BProgress, BModal, BNotification },
  props: {
    isModalActive: {
      type: Boolean,
      required: true,
    },
    modalMessage: {
      type: String,
      required: true,
    },
    uploadProgress: {
      type: Number,
      required: true,
    },
  },
  emits: ["cancel-upload", "continue-navigation"],
  setup(props, { emit }) {
    const isModalActiveComputed = computed(() => props.isModalActive);
    const modalMessageComputed = computed(() => props.modalMessage);
    const uploadProgressComputed = computed(() => props.uploadProgress);

    const cancelUpload = () => {
      emit("cancel-upload");
    };

    const continueNavigation = () => {
      emit("continue-navigation");
    };

    return {
      isModalActiveComputed,
      modalMessageComputed,
      uploadProgressComputed,
      cancelUpload,
      continueNavigation,
    };
  },
};
</script>
